import { SignalTypeMeta } from "@megaron/resource";

import { SupportTicketDoc } from "./ticketDoc";

type SupportDocType = SupportTicketDoc["docType"];

export const supportSignalTypes = {
  unreadTicket: {
    subjectDocType: "support-ticket",
    level: "warning",
    app: "support",
    actionLabel: "Nowy e-mail w zgłoszeniu",
  },
  supportTicketMention: {
    subjectDocType: "support-ticket",
    level: "info",
    app: "support",
    actionLabel: "Oznaczenie w notatce zgłoszenia",
  },
} as const satisfies Record<string, SignalTypeMeta<SupportDocType>>;
